import axios from 'axios';
import axiosInstance from "../util/AxiosInstance/AxiosInstance"

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export const signIn = async ({ email, password }) => {
    try {
        const response = await axiosInstance.post('/admin/signIn', { email, password })

        if (response && response.data) {
            const { accessToken, refreshToken, user } = response.data

            if (!accessToken || !refreshToken || !user) {
                return { success: false, message: "Invalid response from server" }
            }

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            return { success: true, user, message: response.data.message }
        } else {
            // console.log("Error with response from backend:  ", response.data)
            return { success: false, message: 'No response data received' };
        }
    } catch (err) {
        // console.log("Error sending signIn Data to backend:  ", err);
        return { 
            success: false, 
            message: err.response?.data?.message || 'Login Failed. Please try again.' 
        }
    }
}

export const validateToken = async () => {
    try {
        const response = await axiosInstance.get('/admin/validateToken');
        return response.data;
    } catch (error) {
        if (error.response?.data?.error === 'TOKEN_EXPIRED') {
            return error.response.data;
        }
        throw error;
    }
};

export const refreshAccessToken = async () => {
    try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
            throw new Error('No refresh token available');
        }

        const response = await axiosInstance.post('/admin/refresh', {
            refreshToken
        });

        if (response.data.success) {
            localStorage.setItem('accessToken', response.data.accessToken);
            return response.data;
        }
        throw new Error('Failed to refresh token');
    } catch (error) {
        // Clear tokens on refresh failure
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        throw error;
    }
};
